import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import * as React from 'react';
const SvgMenuTriangleDown = ({
  accessibilityText,
  forwardedRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  width: 16,
  height: 16,
  "aria-hidden": accessibilityText ? undefined : true,
  "aria-label": accessibilityText,
  fill: "currentColor",
  focusable: false,
  ref: forwardedRef,
  role: accessibilityText ? 'img' : undefined
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M4 5h8l-4 6z"
}));
export default SvgMenuTriangleDown;